import React, { useRef, useState } from 'react';
import FunctionSidebarContainer from '../common/FunctionSidebar/FunctionSidebarContainer';
import TextField from '@material-ui/core/TextField';
import { Field, Form, Formik } from 'formik';
import StickyBottomButton from '../common/StickyBottomButtonSave/StickyBottomButton';
import AlertSavePage from '../common/AlertSavePage/AlertSavePage';
import { useHistory } from 'react-router-dom';

const ObjectAbout = (props) => {
  const [unsavedPage, toggleUnsavedPage] = useState(false);

  const [targetRedirectLink, setTargetRedirectLink] = useState(false);
  const history = useHistory();

  const { description, savePage, objectId, floorValue, floorTotalCount } =
    props;

  //валидация формы
  const validation = (value) => {
    //если значения формы отличаются от начальных то показывать кнопку сохранить страницу
    if (
      JSON.stringify(formRef.current.initialValues) != JSON.stringify(value)
    ) {
      toggleUnsavedPage(true);
    } else {
      toggleUnsavedPage(false);
    }

    const error = {};
    if (value.description.length >= 2000) {
      error.description = 'Поле не может содержать более 2000 символов';
    }
    return error;
  };

  //реф формы
  const formRef = useRef();

  //переназначенный submit формы
  const handleSubmit = async (values) => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  //сохранение страницы
  const onSubmit = async (values) => {
    toggleUnsavedPage(false);

    let response = await savePage({
      object: objectId,
      section: 'description',
      data: values,
    });
    if (response) {
      if (targetRedirectLink) {
        history.push(targetRedirectLink);
      }
    }
  };

  return (
    <div className='main edit-object'>
      <div className='container-fluid'>
        <div id='description' className='mb-4'>
          <div className='row'>
            <div className='col-12 mb-2'>
              <Formik
                innerRef={formRef}
                enableReinitialize
                initialValues={{
                  description: description ? description : '',
                  floorValue: `${floorValue}` || '',
                  floorTotalCount: `${floorTotalCount}` || '',
                }}
                validate={validation}
                onSubmit={onSubmit}
              >
                {() => (
                  <Form>
                    <div className='row g-3'>
                      {floorValue ? (
                        <div className='col-xl-6'>
                          <Field
                            name='floorValue'
                            validate={(value) => {
                              if (!value) {
                                return 'Поле не заполнено';
                              }
                              if (value < 0) {
                                return 'Значение не должно быть отрицательным';
                              }
                            }}
                          >
                            {({ field, form }) => (
                              <TextField
                                {...field}
                                label='Этаж'
                                fullWidth
                                size='small'
                                variant='outlined'
                                inputProps={{
                                  autoComplete: 'new-password',
                                  form: {
                                    autoComplete: 'new-password',
                                  },
                                }}
                              />
                            )}
                          </Field>
                        </div>
                      ) : null}
                      {floorTotalCount ? (
                        <div className='col-xl-6'>
                          <Field
                            name='floorTotalCount'
                            validate={(value) => {
                              if (!value) {
                                return 'Поле не заполнено';
                              }
                              if (value < 0) {
                                return 'Значение не должно быть отрицательным';
                              }
                            }}
                          >
                            {({ field, form }) => (
                              <TextField
                                {...field}
                                label='Всего этажей'
                                fullWidth
                                size='small'
                                variant='outlined'
                                inputProps={{
                                  autoComplete: 'new-password',
                                  form: {
                                    autoComplete: 'new-password',
                                  },
                                }}
                              />
                            )}
                          </Field>
                        </div>
                      ) : null}
                      <div className='col-xl-12'>
                        <Field name='description'>
                          {({ field, form }) => (
                            <TextField
                              name={field.name}
                              onChange={field.onChange}
                              value={field.value}
                              label='Описание объекта'
                              multiline
                              fullWidth
                              rows={15}
                              variant='outlined'
                              inputProps={{ maxLength: 2000 }}
                              helperText={`${
                                field.value?.length ? field.value?.length : 0
                              }/2000`}
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        {unsavedPage && <StickyBottomButton action={handleSubmit} />}

        <AlertSavePage
          unsavedPage={unsavedPage}
          btnOkAction={handleSubmit}
          setTargetRedirectLink={setTargetRedirectLink}
          targetRedirectLink={targetRedirectLink}
        />
      </div>
      <FunctionSidebarContainer />
    </div>
  );
};

export default ObjectAbout;
